'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Chevron = require('../Chevron');

var _Chevron2 = _interopRequireDefault(_Chevron);

var _taxonomyNodePropType = require('../PropTypes/taxonomyNodePropType');

var _taxonomyNodePropType2 = _interopRequireDefault(_taxonomyNodePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RenderGeoname = function RenderGeoname(_ref) {
  var node = _ref.node,
      onClickNode = _ref.onClickNode,
      onClickLink = _ref.onClickLink;

  var handleClickedButton = function handleClickedButton() {
    onClickNode(node._id);
    onClickLink({
      clickEndLocation: 'Taxonomy Level',
      completion: false,
      linkName: node.name
    }, false);
  };

  return _react2.default.createElement(
    'div',
    { className: 'quiver-taxonomy-navigator__render-geoname' },
    _react2.default.createElement(
      'button',
      { onClick: handleClickedButton },
      _react2.default.createElement(
        'div',
        { className: 'quiver-taxonomy-navigator__render-geoname__button-wrapper' },
        node.name,
        _react2.default.createElement(_Chevron2.default, { direction: 'right' })
      )
    )
  );
};

RenderGeoname.propTypes = {
  node: _taxonomyNodePropType2.default,
  onClickNode: _propTypes2.default.func,
  onClickLink: _propTypes2.default.func
};

exports.default = RenderGeoname;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/TaxonomyNavigator/RenderGeoname.js
// module id = 340
// module chunks = 0